import React from "react";
import { CaseContext, CaseProblem } from "../types";

interface CaseContextProblemProps {
  context: CaseContext;
  problem: CaseProblem;
}

const CaseContextProblem: React.FC<CaseContextProblemProps> = ({
  context,
  problem,
}) => {
  return (
    <div className="flex space-x-4">
      {/* Context Section */}
      <div className="flex-1 rounded-lg p-4">
        <h4 className=" rounded-md text-[#1F2024] font-semibold">
          <span className="bg-[#E6E8EB]   px-4 py-2 rounded-xl">Context</span>
        </h4>
        <div className="mt-3 text-[#474A52] text-[14px] leading-relaxed whitespace-pre-line">
          {context.content}
        </div>
      </div>

      {/* Vertical Separator */}
      <div className="w-[2px] bg-[#E6E8EB]"></div>

      {/* Problem Section */}
      <div className="flex-1 rounded-lg p-4">
        <h4 className="rounded-md text-[#1F2024] font-semibold">
          <span className="bg-[#E6E8EB]  px-4 py-2 rounded-xl">Problem</span>
        </h4>
        <div className="mt-3 text-[#474A52]  text-[14px] leading-relaxed whitespace-pre-line">
          {problem.content}
        </div>
      </div>
    </div>
  );
};

export default CaseContextProblem;
